export default "__VITE_PUBLIC_ASSET__a21d8db0__"